import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './App.scss';
import IntroductionSection from './sections/IntroductionSection/IntroductionSection';
import LegalNote from './sections/LegalNote/LegalNote';
import RatesSection from './sections/RatesSection/RatesSection';
const App = () => {
    return (_jsxs("div", { className: "main-container", children: [_jsx(IntroductionSection, {}), _jsx(RatesSection, {}), _jsx(LegalNote, {})] }));
};
export default App;
